import { IonCol, IonGrid, IonRow } from '@ionic/react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CARE_PROCESS_MODELS } from '../../data/Constants';
import './CareProcessModels.scss';

export const CareProcessModels: React.FC = () => {
  const pageTitle = 'Care Process Models';
  const [data, setData] = React.useState(CARE_PROCESS_MODELS);

  return (
      <div className="page-content ion-margin-bottom">
        <IonGrid className="ios">
          <IonRow className="ion-margin-bottom ion-align-items-left">
            <IonCol
                sizeXs="10"
                size="5"
                sizeSm="8"
                className="ion-no-padding ion-no-margin ion-float-start"
            >
              <h3 className="page-title">{pageTitle}</h3>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              {data.map((model) => (
                  <div key={model.groupName} style={{ marginBottom: '20px' }}>
                    <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <h3>{model.groupName}</h3>
                      </AccordionSummary>
                      <AccordionDetails>
                        {model.sections ? (
                            model.sections.map((section) => (
                                <div key={section.sectionName} style={{ marginBottom: '20px' }}>
                                  <h4>{section.sectionName}</h4>
                                  <ul className="cpm-list">
                                    {section.options.map((opt) => (
                                        <li key={opt.name} style={{ marginBottom: '10px' }}>
                                <span style={{ fontSize: '1em' }}>
                                  {opt.value ? (
                                      <a
                                          href={opt.value}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ textDecoration: 'none' }}
                                          className="cpm-links"
                                      >
                                        {opt.name}
                                      </a>
                                  ) : (
                                      opt.name
                                  )}
                                  {opt.subOptions && (
                                      <ul style={{ marginTop: '10px' }}>
                                        {opt.subOptions.map((subOpt) => (
                                            <li key={subOpt.name} style={{ marginBottom: '5px' }}>
                                          <span style={{ fontSize: '1em' }}>
                                            <a
                                                href={subOpt.value}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none' }}
                                                className="cpm-links"
                                            >
                                              {subOpt.name}
                                            </a>
                                          </span>
                                            </li>
                                        ))}
                                      </ul>
                                  )}
                                </span>
                                        </li>
                                    ))}
                                  </ul>
                                </div>
                            ))
                        ) : (
                            <ul className="cpm-list">
                              {model.options.map((opt) => (
                                  <li key={opt.name} style={{ marginBottom: '10px' }}>
                            <span style={{ fontSize: '1em' }}>
                              <a
                                  href={opt.value}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none' }}
                                  className="cpm-links"
                              >
                                {opt.name}
                              </a>
                              {opt.subOptions && (
                                  <ul style={{ marginTop: '10px' }}>
                                    {opt.subOptions.map((subOpt) => (
                                        <li key={subOpt.name} style={{ marginBottom: '5px' }}>
                                      <span style={{ fontSize: '1em' }}>
                                        <a
                                            href={subOpt.value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none' }}
                                            className="cpm-links"
                                        >
                                          {subOpt.name}
                                        </a>
                                      </span>
                                        </li>
                                    ))}
                                  </ul>
                              )}
                            </span>
                                  </li>
                              ))}
                            </ul>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
              ))}
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
  );
};

export default CareProcessModels;
